// Sub‑reducer for the `hospitalReleasePrevision` slice.
// It stores a simple string representing the prevision date.
import * as types from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import { getAsyncActionTypeFulfiled } from 'app/redux/features/pad-initialization/actions/padInitialization.types';

const initialState = '';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ACTION_TYPES.SET_HOSPITAL_RELEASE_PREVISION:
      return action.payload;
    case getAsyncActionTypeFulfiled(types.ACTION_TYPES.FETCH_PAD_DATA): {
      const pad = action.payload;
      return pad.hospitalReleasePrevision || '';
    }
    case getAsyncActionTypeFulfiled(types.ACTION_TYPES.FETCH_PAD_VISIT_DATA): {
      const padVisit = action.payload;
      const pad = padVisit.pad || {};
      return pad.hospitalReleasePrevision || '';
    }
    case types.ACTION_TYPES.RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
